/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore',
	'react',
	'react-dom',
	'../../nls/StringResources',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-graphics/dist/icons-js/text--bold_32',
	'@ba/ba-graphics/dist/icons-js/text--italic_32',
	'@ba/ba-graphics/dist/icons-js/text--underline_32',
	'@ba/ba-graphics/dist/icons-js/center-align_32',
	'@ba/ba-graphics/dist/icons-js/text--align--left_32',
	'@ba/ba-graphics/dist/icons-js/text--align--right_32',
	'@ba/ba-graphics/dist/icons-js/reset_32',
	'@ba/ba-graphics/dist/icons-js/list--bulleted_32',
	'@ba/ba-graphics/dist/icons-js/list--numbered_32',
	'@ba/ba-graphics/dist/icons-js/text-wrap_32'
], function (View, _, React, ReactDOM, StringResources, ui_toolkit, bold_32, italic_32, underline_32, center_align_32, left_align_32, right_align_32, reset_32, bulleted_list_32, numbered_list_32, text_wrap_32) {

	const TextToolbarCompactDialog = View.extend({

		events: {
		},

		init: function(options) {
			// Setup options for the View base class (such as dimensions)
			TextToolbarCompactDialog.inherited('init', this, arguments);
			this.onStateChange = (options && options.actions && options.actions.apply) || (options && options.onStateChange) || undefined;
			options = options && options.state || options || {};

			// Store options needed specifically for this dialog
			this.properties = options.properties ? options.properties : {};
			this.elementListType = options.elementListType ? options.elementListType : 'default';
			this.supportsLists = options.supportsLists;
			this.supportsTextWrap = options.supportsTextWrap;
			const defaultState = {
				bold: false,
				italic: false,
				underline: false,
				justifyLeft: true,
				justifyCenter: false,
				justifyRight: false,
				color: '#000000',
				font:'ibmplexsans',
				textAlign: 'Left',
				fontSize: 'auto'
			};
			this.initialState = _.extend({}, defaultState, options.initialState);
			this._sanitizeState(this.initialState);
			this.currentState = _.extend({}, this.initialState, options.currentState);
			this._sanitizeState(this.currentState);

			this.mountNode = null;
			this.isRendered = false;
		},

		_sanitizeState: function(state) {
			if (state.justifyCenter) {
				state.justifyLeft = false;
				state.justifyRight = false;
				state.textAlign = 'Center';
			} else if (state.justifyRight) {
				state.justifyLeft = false;
				state.justifyCenter = false;
				state.textAlign = 'Right';
			} else if (state.justifyLeft) {
				state.justifyCenter = false;
				state.justifyRight = false;
				state.textAlign = 'Left';
			} else {
				state.justifyLeft = false;
				state.justifyCenter = false;
				state.justifyRight = false;
				state.textAlign = '';
			}

			return state;
		},

		setState: function (state) {
			this.currentState = this._sanitizeState(state);
			if (this._ToolbarWidget && !this._ToolbarWidget.hasUnmounted) {
				return new Promise((resolve) => {
					this._ToolbarWidget.setState(this.currentState, resolve);
				});
			} else {
				return Promise.resolve();
			}
		},

		_getSelectElementProp(key, domNodeToAttachTo, customWidth, options, selected, onChange){
			return {
				size : 'normal',
				variant:'frameless',
				domNodeToAttachTo : domNodeToAttachTo,
				customWidth: customWidth,
				options: options,
				displayLabel: StringResources.get(key),
				value: selected,
				onChange: onChange,
				key: key
			};
		},

		_createToolBar: function(initialState, containerNode){
			let _ToolbarWidget;
			const _this = this;

			const Select = ui_toolkit.Select;
			const Toolbar = ui_toolkit.Toolbar;
			const Button = ui_toolkit.Button;
			const ColorPicker = ui_toolkit.ColorPicker;
			let colors = _this.properties.colors;
			let fontOptions = _this.properties.fonts;
			let fontSizeOptions = _this.properties.fontSizes;

			const ColorPickerElement = function(key, onChange){
				return React.createElement(
					ColorPicker,
					{
						colors: colors,
						selectedColor: _ToolbarWidget.state.color,
						onColorSelected: function(color) {
							onChange({
								color: color
							});
						},
						key: key,
						title: StringResources.get(key),
						buttonExtraOptions: { size: 'field' },
						colorbarOffset: { top: '22.5px', left: '12px' }
					}
				);
			};

			const ButtonElement = function(id, key, onClick){
				return React.createElement(
					Button,
					{
						icon: id,
						size: 'field',
						kind: 'ghost',
						'data-id': key,
						'walkme-data-id': key,
						title: StringResources.get(key),
						onClick:function(){
							onClick && onClick();
						},
						key: key,
						className: _ToolbarWidget.state[key] ? 'selected': ''
					}
				);
			};

			const SelectFontFaceElement = function(key, containerNode, onChange){
				return React.createElement(
					Select,
					_this._getSelectElementProp(key, containerNode, '150px', fontOptions, _ToolbarWidget.state.font, function(v) {
						onChange({
							font: v
						});
					})
				);
			};

			const SelectFontSizeElement = function(key, containerNode, onChange){
				return React.createElement(
					Select,
					_this._getSelectElementProp(key, containerNode, '120px', fontSizeOptions, _ToolbarWidget.state.fontSize, function(v){
						onChange({
							fontSize: v
						});
					})
				);
			};

			const _getToolbarElementList = function(_ToolbarWidget){

				const onChange = function(changes, options) {
					_ToolbarWidget.setState(changes);
					if (_this.onStateChange) {
						_this.onStateChange(changes, options);
					}
				};

				if(_this.elementListType == 'simpleTextEdit') {
					_ToolbarWidget.toolBarElementsList = [
						SelectFontFaceElement('fontSelect', containerNode, onChange),
						SelectFontSizeElement('fontSizeSelect', containerNode, onChange),
						ColorPickerElement('fontColorPicker', onChange),
						ButtonElement(reset_32.default.id, 'restore',  onChange.bind(this, initialState, true))
					];
				} else {
					_ToolbarWidget.toolBarElementsList = [
						SelectFontFaceElement('fontSelect', containerNode, onChange),
						SelectFontSizeElement('fontSizeSelect', containerNode, onChange),
						ButtonElement(bold_32.default.id, 'bold', onChange.bind(this, { bold: !_ToolbarWidget.state.bold })),
						ButtonElement(italic_32.default.id,'italic', onChange.bind(this, { italic: !_ToolbarWidget.state.italic })),
						ButtonElement(underline_32.default.id, 'underline', onChange.bind(this, { underline: !_ToolbarWidget.state.underline })),
						ColorPickerElement('fontColorPicker', onChange),
						ButtonElement(left_align_32.default.id, 'justifyLeft', onChange.bind(this, { justifyLeft: true, justifyCenter: false, justifyRight: false, textAlign: 'Left' })),
						ButtonElement(center_align_32.default.id, 'justifyCenter', onChange.bind(this, { justifyCenter: true, justifyLeft: false, justifyRight: false, textAlign: 'Center' })),
						ButtonElement(right_align_32.default.id, 'justifyRight', onChange.bind(this, { justifyRight: true, justifyLeft: false, justifyCenter: false, textAlign: 'Right' })),
						... _this.supportsLists ? [
							ButtonElement(bulleted_list_32.default.id, 'insertUnorderedList', onChange.bind(this, { insertUnorderedList: !_ToolbarWidget.state.insertUnorderedList, insertOrderedList: false })),
							ButtonElement(numbered_list_32.default.id, 'insertOrderedList', onChange.bind(this, { insertOrderedList: !_ToolbarWidget.state.insertOrderedList, insertUnorderedList: false }))
						] : [],
						... _this.supportsTextWrap ? [
							ButtonElement(text_wrap_32.default.id, 'textWrap', onChange.bind(this, { textWrap: !_ToolbarWidget.state.textWrap }))
						] : [],
						ButtonElement(reset_32.default.id, 'restore', onChange.bind(this, initialState, { restoreDefaults: true }))
					];
				}
				return _ToolbarWidget.toolBarElementsList;
			};

			/* eslint-disable react/prop-types */
			const ToolbarElement = function(props){
				return React.createElement(Toolbar, null, _getToolbarElementList(props.context));
			};
			/* eslint-enable react/prop-types */

			class ToolBarWidget extends React.Component {
				constructor(props){
					super(props);
					this.state = {
						bold: _this.currentState.bold,
						italic: _this.currentState.italic,
						underline: _this.currentState.underline,
						justifyLeft: _this.currentState.justifyLeft,
						justifyCenter: _this.currentState.justifyCenter,
						justifyRight: _this.currentState.justifyRight,
						fontSize: _this.currentState.fontSize,
						color: _this.currentState.color,
						font: _this.currentState.font,
						textAlign: _this.currentState.textAlign
					};
					if(_this.supportsLists) {
						this.state['insertUnorderedList'] = !!_this.currentState.insertUnorderedList;
						this.state['insertOrderedList'] = !!_this.currentState.insertOrderedList;
					}
					if(_this.supportsTextWrap) {
						this.state['textWrap'] = !!_this.currentState.textWrap;
					}
					this.toolBarElementsList = [];
				}

				render() {
					_ToolbarWidget = this;
					_this._ToolbarWidget = _ToolbarWidget;
					return React.createElement(
						'div',
						{ key: 'container' },
						[
							React.createElement(ToolbarElement, { context : this, key: 'toolbar', elementListType: _this.elementListType })
						]
					);

				}
			}

			return ToolBarWidget;
		},

		_renderReactToolBar: function(){
			const toolbar = this._createToolBar(this.initialState, this.mountNode);

			return new Promise((resolve, reject) => {
				try {
					ReactDOM.render(React.createElement(toolbar), this.mountNode, resolve);
				} catch(error) {
					reject(error);
				}
			});
		},

		remove: function() {
			if (this.mountNode) {
				ReactDOM.unmountComponentAtNode(this.mountNode);
				this.mountNode = null;
			}
			this.isRendered = false;
		},

		render: function() {
			if (!this.isRendered) { //TODO: Revisit all the areas where the text toolbar is used to ensure that we no longer render an already rendered toolbar, then remove this check.
				this.$el
					.addClass('popoverDialogContainer')
					.html('<div class="ba-theme-waca textToolbarContainer"></div>');
				this.mountNode = this.$el.find('.textToolbarContainer').get(0);
				this.isRendered = true;
				return this._renderReactToolBar();
			} else {
				return Promise.resolve();
			}
		},

		setFocus: function() {
			var buttons = this.$el.find('button');
			if (buttons.length > 0) {
				buttons[0].focus();
			}
		}

	});

	return TextToolbarCompactDialog;
});
